import { gql } from '@apollo/client';

import { FETCH_NOTIFICATION_RULES_FIND_ONE_FRAGMENT } from './fragments';

export const FETCH_NOTIFICATION_RULES_QUERY = gql`
  query NotificationRules_Find($input: BrandInput!) {
    NotificationRules_Find(input: $input) {
      count
      rules {
        id
        name
        isActive
        events
        condition {
          logOp
          conditions {
            conditions {
              param
              op
              type
              value
            }
            logOp
            op
            param
            type
            value
          }
        }
        whatsapp {
          useDelay
          delayType
          delay
          sendTo
        }
        sms {
          useDelay
          delayType
          delay
          sendTo
        }
        email {
          useDelay
          delayType
          delay
          sendTo
        }
      }
    }
  }
`;

export const FETCH_NOTIFICATION_RULES_FIND_ONE_QUERY = gql`
  query FetchNotificationRulesFindOneQuery($input: IdInput!) {
    NotificationRules_FindOne(input: $input) {
      ...NotificationRules_FindOneFragment
    }
  }
  ${FETCH_NOTIFICATION_RULES_FIND_ONE_FRAGMENT}
`;
